module.exports = __webpack_public_path__ + "media/images/fIPrVNrF-7c1626ff7a8338eca567f357dad59954.jpeg";